import { UrlMatchResult, UrlSegment } from '@angular/router';
import { getSuffixUrlMatcher } from '@spartacus/storefront';

/**
 * Matches pattern `** / category/:categoryCode`
 * @param segments
 */
export function customProductListUrlMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const suffixPLPMatcher = getSuffixUrlMatcher({
    marker: 'category',
    paramName: 'categoryCode',
  });

  return suffixPLPMatcher(segments);
}
